import { render, staticRenderFns } from "./yc-sales-customer-details.vue?vue&type=template&id=670197d0&"
import script from "./yc-sales-customer-details.vue?vue&type=script&lang=js&"
export * from "./yc-sales-customer-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports